import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { SortDirection } from "@redotech/redo-views-common/table";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const customNumberKeys = [
  "customNumber1",
  "customNumber2",
  "customNumber3",
  "customAttributeNumber1",
  "customAttributeNumber2",
  "customAttributeNumber3",
] as const;

export function CustomNumberColumn({
  title,
  key,
}: {
  title: string;
  key: (typeof customNumberKeys)[number];
}): Column2<FulfillmentGroupData> {
  return {
    alignment: ColumnAlignment.RIGHT,
    key,
    title,
    renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => (
      <RedoTableTextCell
        text={row[key] ? row[key].map((num) => num.toString()).join(", ") : ""}
      />
    ),
    width: 100,
    sort: SortDirection.DESC,
  };
}
